// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-member[data-v-6fbd072a] {
  position: relative;
  display: flex;
  overflow: hidden;
}
.grid-member.no-camera[data-v-6fbd072a] {
  background-color: var(--vm-nocamera-bg);
}
.grid-member.no-camera .name[data-v-6fbd072a] {
  padding: 0 5px;
}
.grid-member .name[data-v-6fbd072a] {
  margin: auto;
  color: white;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.grid-member .reactions-wrapper[data-v-6fbd072a] {
  position: absolute;
  display: flex;
  flex-direction: row;
  left: 0;
  top: 0;
}
.grid-member .reactions-wrapper .reaction[data-v-6fbd072a] {
  margin: auto;
  padding: 5px;
}
.grid-member .status-wrapper[data-v-6fbd072a],
.grid-member .more-wrapper[data-v-6fbd072a] {
  position: absolute;
  display: flex;
  background-color: #5f585185;
  color: white;
}
.grid-member .more-wrapper[data-v-6fbd072a] {
  display: none;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding-right: 1px;
}
.grid-member .more-wrapper i[data-v-6fbd072a] {
  margin: auto;
}
.grid-member:hover .more-wrapper[data-v-6fbd072a] {
  display: flex;
}
.grid-member .status-wrapper[data-v-6fbd072a] {
  max-width: 100%;
  left: 0;
  bottom: 0;
}
.grid-member .status-wrapper > .name[data-v-6fbd072a] {
  margin: 0 5px;
}
.grid-member .status-wrapper .status-icon[data-v-6fbd072a] {
  width: 20px;
  height: 20px;
  display: flex;
  padding-top: 1px;
}
.grid-member .status-wrapper .status-icon i[data-v-6fbd072a] {
  margin: auto;
}
.grid-member .status-wrapper .status-icon i.transparent[data-v-6fbd072a] {
  opacity: 0.5;
}
.grid-member .status-wrapper .status-icon i.color-red[data-v-6fbd072a] {
  color: var(--elem-red-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfGridItem.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,MAAM;AACR;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,OAAO;EACP,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[".grid-member[data-v-6fbd072a] {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n}\n.grid-member.no-camera[data-v-6fbd072a] {\n  background-color: var(--vm-nocamera-bg);\n}\n.grid-member.no-camera .name[data-v-6fbd072a] {\n  padding: 0 5px;\n}\n.grid-member .name[data-v-6fbd072a] {\n  margin: auto;\n  color: white;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.grid-member .reactions-wrapper[data-v-6fbd072a] {\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  left: 0;\n  top: 0;\n}\n.grid-member .reactions-wrapper .reaction[data-v-6fbd072a] {\n  margin: auto;\n  padding: 5px;\n}\n.grid-member .status-wrapper[data-v-6fbd072a],\n.grid-member .more-wrapper[data-v-6fbd072a] {\n  position: absolute;\n  display: flex;\n  background-color: #5f585185;\n  color: white;\n}\n.grid-member .more-wrapper[data-v-6fbd072a] {\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  padding-right: 1px;\n}\n.grid-member .more-wrapper i[data-v-6fbd072a] {\n  margin: auto;\n}\n.grid-member:hover .more-wrapper[data-v-6fbd072a] {\n  display: flex;\n}\n.grid-member .status-wrapper[data-v-6fbd072a] {\n  max-width: 100%;\n  left: 0;\n  bottom: 0;\n}\n.grid-member .status-wrapper > .name[data-v-6fbd072a] {\n  margin: 0 5px;\n}\n.grid-member .status-wrapper .status-icon[data-v-6fbd072a] {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  padding-top: 1px;\n}\n.grid-member .status-wrapper .status-icon i[data-v-6fbd072a] {\n  margin: auto;\n}\n.grid-member .status-wrapper .status-icon i.transparent[data-v-6fbd072a] {\n  opacity: 0.5;\n}\n.grid-member .status-wrapper .status-icon i.color-red[data-v-6fbd072a] {\n  color: var(--elem-red-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
